import { NumberFormComponent } from "components/Form/components/Number/NumberFormComponent";
import { useWorkspaceConfigValue } from "containers/WorkspaceConfig/useWorkspaceConfigValue";
import { useCallback } from "react";
import { Field } from "react-final-form";

export const setDefaultPriorityMutator = ({ state, utils, defaultPriorityValue }) => {
    if ((state.formState.values as any)?.priority == null) {
        utils.changeValue(state, "priority", () => defaultPriorityValue);
    }
};

export const useGetPriority = () => {
    const defaultPriorityValue = useWorkspaceConfigValue("EXECUTION_DEFAULT_PRIORITY");

    const getPriorityValue = useCallback(
        (formValue) => +(formValue ?? defaultPriorityValue),
        [defaultPriorityValue]
    );

    return { getPriorityValue, defaultPriorityValue };
};

export const ExecutionPriorityField = ({
    onBlur,
    label,
    isDisabled,
    initialValue,
}: {
    onBlur?: (e) => void;
    label?: string;
    isDisabled?: boolean;
    initialValue?: number;
}) => (
    <Field
        name="priority"
        component={NumberFormComponent}
        fieldProps={{
            label,
            onBlur,
            docs: {
                urlPath: "/docs/executions#execution-priority",
            },
        }}
        fieldAttr={{
            disabled: isDisabled,
        }}
        initialValue={initialValue}
    />
);
